export function extendWithFaceDescriptor(sourceObj, descriptor) {
    var extension = { descriptor: descriptor };
    return Object.assign({}, sourceObj, extension);
}
//# sourceMappingURL=WithFaceDescriptor.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/face-api.js/build/es6/factories/WithFaceDescriptor.js
// module id = 1064
// module chunks = 0